"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validators = exports.validate = exports.renderField = exports.renderExpiryDate = exports.renderCreditCardField = exports.default = exports.FieldGroup = exports.Container = exports.CardAccpetedNoteContainer = exports.ActionButtonContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _dateFns = require("date-fns");
var _formik = require("formik");
var _Switch = _interopRequireDefault(require("@material-ui/core/Switch"));
var _cardValidator = _interopRequireDefault(require("card-validator"));
var _utilities = _interopRequireDefault(require("../../utilities"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Text = _interopRequireDefault(require("../Text"));
var _TextField = _interopRequireDefault(require("../TextField"));
var _DateInput = _interopRequireDefault(require("../DateInput"));
var _CreditCardField = _interopRequireDefault(require("../CreditCardField"));
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var _GuestPersonalInfo = require("../GuestPersonalInfo");
var _utils = require("../CreditCardField/utils");
var _CreditCardForm = _interopRequireDefault(require("./CreditCardForm.proptypes"));
var _constant = require("../Button/constant");
var _constant2 = require("../constant");
var _constants = require("./constants");
var _GenericPopUp = _interopRequireDefault(require("../GenericPopUp"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Shimmer = _interopRequireDefault(require("../Shimmer"));
var _excluded = ["form", "handleField"],
  _excluded2 = ["form", "handleField"],
  _excluded3 = ["form", "handleField", "isMobile", "isPaymentPage", "touched"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// Register BigPay configuration
_cardValidator.default.creditCardType.addCard({
  niceType: 'BigPay',
  type: 'big-pay',
  patterns: [559998],
  gaps: [4, 8, 12],
  lengths: [16],
  code: {
    name: 'CVV',
    size: 3
  }
});
var Container = _styledComponents.default.div.withConfig({
  displayName: "CreditCardForm__Container",
  componentId: "sc-1hdewgn-0"
})(["display:flex;flex-wrap:wrap;"]);
exports.Container = Container;
var FieldGroup = _styledComponents.default.div.withConfig({
  displayName: "CreditCardForm__FieldGroup",
  componentId: "sc-1hdewgn-1"
})(["width:100%;display:flex;flex-wrap:", ";"], function (_ref) {
  var flexWrap = _ref.flexWrap;
  return flexWrap ? 'wrap' : 'nowrap';
});
exports.FieldGroup = FieldGroup;
var ActionButtonContainer = _styledComponents.default.div.withConfig({
  displayName: "CreditCardForm__ActionButtonContainer",
  componentId: "sc-1hdewgn-2"
})(["width:100%;margin:10px 0 0 0;padding:", ";display:flex;justify-content:flex-end;"], function (_ref2) {
  var theme = _ref2.theme,
    title = _ref2.title;
  return title ? "".concat(theme.space.none, " ").concat(theme.space.tiny, " ").concat(theme.space.none, " ").concat(theme.space.tiny) : "".concat(theme.space.tiny, " ").concat(theme.space.tiny);
});
exports.ActionButtonContainer = ActionButtonContainer;
var CardAccpetedNoteContainer = _styledComponents.default.div.withConfig({
  displayName: "CreditCardForm__CardAccpetedNoteContainer",
  componentId: "sc-1hdewgn-3"
})(["padding:10px;"]);
exports.CardAccpetedNoteContainer = CardAccpetedNoteContainer;
var StyledSwitchWrapper = _styledComponents.default.div.withConfig({
  displayName: "CreditCardForm__StyledSwitchWrapper",
  componentId: "sc-1hdewgn-4"
})(["display:flex;align-items:center;.MuiSwitch-root{width:44px;height:21px;padding:4px;margin-right:", ";}.MuiButtonBase-root{padding:0px;}.MuiSwitch-thumb{color:", ";border:1px solid ", ";height:18px;width:18px;}.MuiSwitch-track{background-color:", ";}.Mui-checked{.MuiSwitch-thumb{color:", ";}&.MuiSwitch-colorSecondary{color:", ";& + .MuiSwitch-track{background-color:", ";}}&:hover.MuiSwitch-colorSecondary{background-color:rgba(75,79,166,0.04);}}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.tiny;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.default;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.secondary;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.greyDark;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.secondary;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.secondary;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.secondary;
});
StyledSwitchWrapper.displayName = 'StyledSwitchWrapper';
var DefaultCardConfirmationModal = _styledComponents.default.div.withConfig({
  displayName: "CreditCardForm__DefaultCardConfirmationModal",
  componentId: "sc-1hdewgn-5"
})(["& [role='dialog']{border-radius:4px;min-height:auto;& > div{margin-top:1rem;flex:0;}}"]);
var ProcessingFeeWrapper = _styledComponents.default.div.withConfig({
  displayName: "CreditCardForm__ProcessingFeeWrapper",
  componentId: "sc-1hdewgn-6"
})(["padding:10px 0 0 0;color:", ";font-family:", ";font-size:", ";display:flex;align-items:center;"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.greyDark;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontFamily.default;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.fontSize.small;
});
var validators = function validators(value, field, translation, validations) {
  for (var _len = arguments.length, customData = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
    customData[_key - 4] = arguments[_key];
  }
  var error;

  /* istanbul ignore next */
  validations.forEach(function (validator) {
    var validationError = validator.apply(void 0, [value, field, translation].concat(customData));
    if (validationError) error = validationError;
  });

  /* istanbul ignore next */
  return error;
};
exports.validators = validators;
var _validate = {
  required: function required(errorMessage) {
    return function (value, field, translation) {
      return value && value.toString() ? '' : errorMessage || translation.requiredError;
    };
  },
  alphabet: function alphabet(value, field, translation) {
    return value && !_constants.CREDIT_CARD_NAME_REGEX.test(value) ? translation.alphabetError : '';
  },
  date: function date(value, field, translation) {
    var error = '';
    if (value) {
      var expiryDatePattern = /^(0[1-9]|1[0-2])\/?([0-9]{4}|[0-9]{2})$/;
      var isValidExpiryDate = expiryDatePattern.test(value);
      if (isValidExpiryDate) {
        var expiryMonthYear = value.split('/');
        var expiryMonth = expiryMonthYear[0] - 1;
        var expiryFullYear = +new Date().getFullYear().toString().slice(0, 2) + expiryMonthYear[1];
        var dateVal = new Date(expiryFullYear, expiryMonth);
        var yearsDiff = (0, _dateFns.differenceInCalendarYears)(dateVal, new Date());
        var monthDiff = (0, _dateFns.differenceInCalendarMonths)(dateVal, new Date());
        if (yearsDiff < 0 || monthDiff <= 0) {
          error = translation.expiredCardError;
        }
      } else {
        error = translation.cardExpiryDateInvalid || translation.invalid;
      }
    }
    return error;
  },
  maxlengthCVV: function maxlengthCVV(value, field, translation, _ref13) {
    var _ref14 = (0, _slicedToArray2.default)(_ref13, 1),
      cvvMaxLength = _ref14[0];
    if (!value) return '';
    var error = '';
    if (value.length > cvvMaxLength) {
      error = translation.cardCvvInvalid || translation.invalidCvv;
    }
    return error;
  },
  numberCVV: function numberCVV(value, field, translation) {
    return value && !_constants.NUMBER_REGEX.test(value) ? translation.cardCvvInvalid || translation.invalidCvv : '';
  },
  creditCard: function creditCard(value, field, translation) {
    var trimValue = value.replace(/\s/g, '');
    /**
     * Check if the hash card number is valid format
     * if TRUE = skip validate card number
     */
    var isValidHashedNumber = /^(\d{6}X{6}\d{4})$/.test(trimValue);
    if (isValidHashedNumber === true) return '';
    var cardInfo = _cardValidator.default.number(trimValue);
    if (cardInfo.isValid === false) {
      return translation.cardNumberInvalid || translation.invalidCardNumber;
    }
    return '';
  }
};
exports.validate = _validate;
var renderField = function renderField(fieldProps) {
  var _fieldProps$customPro;
  var form = fieldProps.form,
    handleField = fieldProps.handleField,
    rest = (0, _objectWithoutProperties2.default)(fieldProps, _excluded);
  var errors = form.errors;
  var field = rest.field.name;
  return /*#__PURE__*/_react.default.createElement(_TextField.default, (0, _extends2.default)({}, rest, {
    maxInputLength: fieldProps === null || fieldProps === void 0 || (_fieldProps$customPro = fieldProps.customProperties) === null || _fieldProps$customPro === void 0 ? void 0 : _fieldProps$customPro.maxlength,
    type: fieldProps.type ? fieldProps.type : 'text',
    onChange: function onChange(e) {
      var _fieldProps$customPro2, _fieldProps$customPro3;
      var val = e.target.value;
      if (fieldProps !== null && fieldProps !== void 0 && (_fieldProps$customPro2 = fieldProps.customProperties) !== null && _fieldProps$customPro2 !== void 0 && _fieldProps$customPro2.maxlength && (fieldProps === null || fieldProps === void 0 || (_fieldProps$customPro3 = fieldProps.customProperties) === null || _fieldProps$customPro3 === void 0 ? void 0 : _fieldProps$customPro3.maxlength) <= e.target.value.length) {
        val = val.slice(0, -1);
      }
      form.setValues(_objectSpread(_objectSpread({}, form.values), {}, (0, _defineProperty2.default)({}, field, val)));
      form.setFieldTouched(field, true, false);
      handleField((0, _defineProperty2.default)({}, field, e.target.value));
    },
    onBlur: function onBlur(e) {
      form.setValues(_objectSpread(_objectSpread({}, form.values), {}, (0, _defineProperty2.default)({}, field, e.target.value !== '' || e.target.value !== null ? e.target.value.replace(/\s{2,}/g, ' ').trim() : e.target.value)));
      form.setFieldTouched(field, true, true);
      handleField((0, _defineProperty2.default)({}, field, e.target.value));
    },
    validateMessage: errors[field] || ''
  }, form.touched[field] && {
    validateStatus: errors[field] ? 'error' : 'success'
  }));
};
exports.renderField = renderField;
var renderCreditCardField = function renderCreditCardField(fieldProps) {
  var _fieldProps$customPro4;
  var form = fieldProps.form,
    handleField = fieldProps.handleField,
    rest = (0, _objectWithoutProperties2.default)(fieldProps, _excluded2);
  var errors = form.errors;
  var field = rest.field.name;
  return /*#__PURE__*/_react.default.createElement(_CreditCardField.default, (0, _extends2.default)({}, rest, {
    maxInputLength: fieldProps === null || fieldProps === void 0 || (_fieldProps$customPro4 = fieldProps.customProperties) === null || _fieldProps$customPro4 === void 0 ? void 0 : _fieldProps$customPro4.maxlength,
    onChange: function onChange(e) {
      form.setValues(_objectSpread(_objectSpread({}, form.values), {}, (0, _defineProperty2.default)({}, field, e)));
      form.setFieldTouched(field, true, false);
      handleField((0, _defineProperty2.default)({}, field, e));
    },
    onBlur: function onBlur(e) {
      form.setValues(_objectSpread(_objectSpread({}, form.values), {}, (0, _defineProperty2.default)({}, field, e.target.value)));
      form.setFieldTouched(field, true, true);
      handleField((0, _defineProperty2.default)({}, field, e.target.value));
    },
    validateMessage: errors[field] || ''
  }, form.touched[field] && {
    validateStatus: errors[field] ? 'error' : 'success'
  }));
};
exports.renderCreditCardField = renderCreditCardField;
var renderExpiryDate = function renderExpiryDate(fieldProps) {
  var form = fieldProps.form,
    handleField = fieldProps.handleField,
    isMobile = fieldProps.isMobile,
    isPaymentPage = fieldProps.isPaymentPage,
    touched = fieldProps.touched,
    rest = (0, _objectWithoutProperties2.default)(fieldProps, _excluded3);
  var errors = form.errors;
  var field = rest.field.name;
  return /*#__PURE__*/_react.default.createElement(_DateInput.default, (0, _extends2.default)({}, rest, {
    isMobile: isMobile && !isPaymentPage // Always render desktop version for payment page
    ,
    dateFormat: _constants.EXPIRY_DATE_FORMAT,
    onChange: function onChange(e) {
      form.setValues(_objectSpread(_objectSpread({}, form.values), {}, (0, _defineProperty2.default)({}, field, e.target.value)));
      form.setFieldTouched(field, true, false);
      handleField((0, _defineProperty2.default)({}, field, e.target.value));
    },
    onBlur: function onBlur(e) {
      form.setValues(_objectSpread(_objectSpread({}, form.values), {}, (0, _defineProperty2.default)({}, field, e.target.value)));
      form.setFieldTouched(field, true, true);
      handleField((0, _defineProperty2.default)({}, field, e.target.value));
    },
    validateMessage: errors[field] || ''
  }, touched && fieldProps.isRequired && {
    validateStatus: errors[field] ? 'error' : 'success'
  }));
};
exports.renderExpiryDate = renderExpiryDate;
var CreditCardForm = function CreditCardForm(_ref15) {
  var accessible = _ref15.accessible,
    theme = _ref15.theme,
    formRef = _ref15.formRef,
    customProperties = _ref15.customProperties,
    initialValues = _ref15.initialValues,
    translation = _ref15.translation,
    onSubmit = _ref15.onSubmit,
    handleField = _ref15.handleField,
    disableFields = _ref15.disableFields,
    disableCreditCard = _ref15.disableCreditCard,
    showDefaultCardToggle = _ref15.showDefaultCardToggle,
    isToggle = _ref15.isToggle,
    onErrors = _ref15.onErrors,
    isPaymentPage = _ref15.isPaymentPage,
    showPaymentCheckbox = _ref15.showPaymentCheckbox,
    maskedCVV = _ref15.maskedCVV,
    showCardAcceptedMessage = _ref15.showCardAcceptedMessage,
    processingFee = _ref15.processingFee,
    askConfirmationForMakingDefaultCard = _ref15.askConfirmationForMakingDefaultCard,
    resetDefaultCardOnCancelSave = _ref15.resetDefaultCardOnCancelSave,
    showDefaultCardInfoTooltip = _ref15.showDefaultCardInfoTooltip,
    isFetchingProcessingFee = _ref15.isFetchingProcessingFee;
  var innerWidth = function innerWidth() {
    return typeof window !== 'undefined' ? window.innerWidth : 300;
  };
  var _useState = (0, _react.useState)(innerWidth()),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    windowWidth = _useState2[0],
    setWindowWidth = _useState2[1];
  var _useState3 = (0, _react.useState)(_objectSpread({}, initialValues)),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    formValue = _useState4[0],
    setFormValue = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    showDefaultCardConfirmationModal = _useState6[0],
    setShowDefaultCardConfirmationModal = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    showDefaultCardInfoModal = _useState8[0],
    setShowDefaultCardInfoModal = _useState8[1];
  var _useState9 = (0, _react.useState)(),
    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
    cardInfo = _useState10[0],
    setCardInfo = _useState10[1];
  (0, _react.useEffect)(function () {
    setFormValue(_objectSpread({}, initialValues));
  }, [initialValues]);
  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', function () {
        return setWindowWidth(innerWidth());
      });
    }
    return function () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', function () {
          return setWindowWidth(innerWidth());
        });
      }
    };
  }, []);
  var _useState11 = (0, _react.useState)(initialValues.preferredCard || false),
    _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
    isDefaultCardChecked = _useState12[0],
    setIsDefaultCardChecked = _useState12[1];
  var _useState13 = (0, _react.useState)(initialValues.saveCard || false),
    _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
    isSaveCardChecked = _useState14[0],
    setisSaveCardChecked = _useState14[1];
  var isMobile = windowWidth <= parseInt(_constant2.BREAKPOINTS.MOBILE.replace('px', ''), 10);
  var language = _objectSpread(_objectSpread({}, _constants.TRANSLATION), translation);
  var defaultCardChangeHandler = function defaultCardChangeHandler() {
    if (!isDefaultCardChecked && askConfirmationForMakingDefaultCard) {
      setShowDefaultCardConfirmationModal(true);
    } else {
      setIsDefaultCardChecked(function (prevState) {
        return !prevState;
      });
    }
  };
  var onCancelDefaultCard = function onCancelDefaultCard() {
    setShowDefaultCardConfirmationModal(false);
    setIsDefaultCardChecked(false);
  };
  var onConfirmDefaultCard = function onConfirmDefaultCard() {
    setShowDefaultCardConfirmationModal(false);
    setIsDefaultCardChecked(true);
  };
  var savedCardChangeHandler = function savedCardChangeHandler() {
    if (isSaveCardChecked && resetDefaultCardOnCancelSave) {
      setIsDefaultCardChecked(false);
    }
    handleField({
      saveCard: !isSaveCardChecked
    });
    setisSaveCardChecked(function (prevState) {
      return !prevState;
    });
  };
  (0, _react.useEffect)(function () {
    handleField({
      preferredCard: isDefaultCardChecked
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDefaultCardChecked]);
  var submitHandler = function submitHandler(creditCardFormValue) {
    var cardNumber = (0, _utils.getCurrentValue)(creditCardFormValue.cardNumber);
    var expiryMonthYear = creditCardFormValue.expiryDate.split('/');
    var expiryMonth = expiryMonthYear[0] - 1;
    var expiryFullYear = +new Date().getFullYear().toString().slice(0, 2) + expiryMonthYear[1];
    var formattedExpiryDate = (0, _dateFns.format)(new Date(expiryFullYear, expiryMonth), 'MMyyyy');
    var data = {
      cardNumber: cardNumber,
      cardholderName: creditCardFormValue.cardholderName,
      expiryDate: formattedExpiryDate,
      preferredCard: isDefaultCardChecked,
      cvv: creditCardFormValue.cvv
    };
    if (isPaymentPage) data = _objectSpread(_objectSpread({}, data), {}, {
      saveCard: isSaveCardChecked
    });
    onSubmit(_objectSpread({}, data));
  };
  var getFormatedProcessingFeeAmount = function getFormatedProcessingFeeAmount() {
    return _utilities.default.formatAmount(processingFee === null || processingFee === void 0 ? void 0 : processingFee.amount, 2, processingFee === null || processingFee === void 0 ? void 0 : processingFee.currency);
  };
  var cardHolderNameField = function cardHolderNameField(fieldProps, isFullWidth) {
    return /*#__PURE__*/_react.default.createElement(_GuestPersonalInfo.FieldWrapper, {
      isMobile: isMobile,
      isFullWidth: isFullWidth
    }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
      component: renderField,
      accessible: accessible,
      alwaysShowLabel: false,
      label: language.cardholderName || _constants.FIELDS.cardholderName.label,
      name: _constants.FIELDS.cardholderName.name,
      theme: theme,
      handleField: handleField,
      value: fieldProps.values[_constants.FIELDS.cardholderName.name],
      disabled: disableFields,
      validate: function validate(val) {
        return validators(val, language.cardholderName || _constants.FIELDS.cardholderName.label, language, [_validate.required(language.cardHolderNameInvalid), _validate.alphabet]);
      }
    }));
  };
  var expiryDateField = function expiryDateField(fieldProps) {
    return /*#__PURE__*/_react.default.createElement(_GuestPersonalInfo.FieldWrapper, {
      isMobile: isMobile
    }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
      component: renderExpiryDate,
      accessible: accessible,
      isMobile: isMobile,
      isPaymentPage: isPaymentPage,
      alwaysShowLabel: false,
      label: language.expiryDate || _constants.FIELDS.expiryDate.label,
      name: _constants.FIELDS.expiryDate.name,
      theme: theme,
      handleField: handleField,
      value: fieldProps.values[_constants.FIELDS.expiryDate.name],
      disabled: disableFields,
      validate: function validate(val) {
        return validators(val, language.expiryDate || _constants.FIELDS.expiryDate.label, language, [_validate.required(language.cardExpiryDateInvalid), _validate.date]);
      },
      isRequired: true,
      touched: fieldProps.touched[_constants.FIELDS.expiryDate.name]
    }));
  };
  var cvvField = function cvvField(fieldProps) {
    var _cardInfo$code;
    var cvvMaxLength = (cardInfo === null || cardInfo === void 0 || (_cardInfo$code = cardInfo.code) === null || _cardInfo$code === void 0 ? void 0 : _cardInfo$code.size) || _constants.CVV_MAXLENGTH;
    return /*#__PURE__*/_react.default.createElement(_GuestPersonalInfo.FieldWrapper, {
      isMobile: isMobile
    }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
      component: renderField,
      customProperties: {
        maxlength: cvvMaxLength
      },
      type: maskedCVV ? 'password' : 'number',
      accessible: accessible,
      alwaysShowLabel: false,
      label: language.cvv || _constants.FIELDS.cvv.label,
      name: _constants.FIELDS.cvv.name,
      theme: theme,
      handleField: handleField,
      value: fieldProps.values[_constants.FIELDS.cvv.name],
      disabled: disableFields,
      showIcon: true,
      icon: "CvvIcon",
      validate: function validate(val) {
        return validators(val, language.cvv || _constants.FIELDS.cvv.label, language, [_validate.required(language.cardCvvInvalid), _validate.maxlengthCVV, _validate.numberCVV], [cvvMaxLength]);
      }
    }));
  };
  var renderDefaultCardText = function renderDefaultCardText() {
    return /*#__PURE__*/_react.default.createElement(_Text.default, {
      type: "sub",
      theme: theme,
      accessible: accessible,
      verticalAlign: "center"
    }, language.defaultCard, " \xA0", showDefaultCardInfoTooltip &&
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    _react.default.createElement("span", {
      role: "button",
      tabIndex: 0,
      onClick: function onClick() {
        return setShowDefaultCardInfoModal(true);
      }
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: "InfoOutlinedIcon",
      theme: theme,
      accessible: accessible,
      color: "secondaryBlue",
      fontsize: "titleSmall"
    })));
  };

  /**
   * text in confirmation modal vary depending on user filled valid card details or not
   * @param {props} formikProps formik object that contains form data like error and values
   * @returns string
   */
  var getPreferredPaymentConfirmationText = function getPreferredPaymentConfirmationText(formikProps) {
    var _formikProps$values, _formikProps$errors;
    var preferredPaymentConfirmationText = language.defaultCardConfirmationModal.preferredPaymentConfirmation;
    var cardNumber = formikProps === null || formikProps === void 0 || (_formikProps$values = formikProps.values) === null || _formikProps$values === void 0 ? void 0 : _formikProps$values.cardNumber;
    var cardNumberError = formikProps === null || formikProps === void 0 || (_formikProps$errors = formikProps.errors) === null || _formikProps$errors === void 0 ? void 0 : _formikProps$errors.cardNumber;
    if (!cardNumberError && cardNumber && cardInfo) {
      var cardLastFourDigit = cardNumber.toString().substr(-4);
      var cardType = cardInfo.niceType;
      if (cardLastFourDigit && cardType) {
        preferredPaymentConfirmationText = _utilities.default.transformText(language.defaultCardConfirmationModal.preferredPaymentConfirmationWithCardDetails, [cardType, cardLastFourDigit]);
      }
    }
    return preferredPaymentConfirmationText;
  };
  var paymentPageCheckbox = function paymentPageCheckbox() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(FieldGroup, null, /*#__PURE__*/_react.default.createElement(_GuestPersonalInfo.FieldWrapper, {
      isFullWidth: true
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      accessible: accessible,
      isSelected: isSaveCardChecked,
      onChange: savedCardChangeHandler,
      text: language.saveCardCheckbox,
      theme: theme,
      disableBottomMargin: true
    }))), isSaveCardChecked && /*#__PURE__*/_react.default.createElement(FieldGroup, null, /*#__PURE__*/_react.default.createElement(_GuestPersonalInfo.FieldWrapper, {
      isFullWidth: true
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      accessible: accessible,
      isSelected: isDefaultCardChecked,
      onChange: defaultCardChangeHandler,
      text: renderDefaultCardText(),
      theme: theme,
      disableBottomMargin: true
    }))));
  };
  var isMoveTheme = theme === 'AIRASIA_MOVE';
  var buttonThemeOverrides = _constant.MOVE_BUTTON_THEME_OVERRIDES[isMoveTheme ? 'AIRASIA_MOVE' : 'AIRASIA_CLASSIC'];
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_formik.Formik, (0, _extends2.default)({
    innerRef: formRef,
    initialValues: formValue,
    onSubmit: submitHandler,
    enableReinitialize: true
  }, customProperties), function (props) {
    var _Object$keys;
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
      _react.default.createElement("form", {
        onSubmit: props.handleSubmit,
        onKeyDown: function onKeyDown(e) {
          if (e.key === 'Enter') {
            props.handleSubmit();
          }
        }
      }, onErrors && onErrors(props.errors), /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(FieldGroup, null, /*#__PURE__*/_react.default.createElement(_GuestPersonalInfo.FieldWrapper, {
        isMobile: isMobile,
        isFullWidth: isPaymentPage
      }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
        component: renderCreditCardField,
        customProperties: {
          maxlength: 19
        },
        onCardInfoChange: function onCardInfoChange(info) {
          return setCardInfo(info);
        },
        accessible: accessible,
        alwaysShowLabel: false,
        label: language.cardNumber || _constants.FIELDS.cardNumber.label,
        name: _constants.FIELDS.cardNumber.name,
        theme: theme,
        handleField: handleField,
        value: props.values[_constants.FIELDS.cardNumber.name],
        disabled: disableCreditCard || disableFields,
        validate: function validate(val) {
          return validators(val, language.cardNumber || _constants.FIELDS.cardNumber.label, language, [_validate.required(language.cardNumberInvalid), _validate.creditCard]);
        }
      }), isFetchingProcessingFee && /*#__PURE__*/_react.default.createElement(ProcessingFeeWrapper, null, "".concat(translation.processingFee, ": "), " \xA0", /*#__PURE__*/_react.default.createElement(_Shimmer.default, {
        accessible: true,
        borderRadius: "4px",
        customProperties: {},
        height: "12px",
        theme: "AIRASIA_CLASSIC",
        width: "70px"
      })), processingFee && !!((_Object$keys = Object.keys(processingFee)) !== null && _Object$keys !== void 0 && _Object$keys.length) && !isFetchingProcessingFee && /*#__PURE__*/_react.default.createElement(ProcessingFeeWrapper, null, "".concat(translation.processingFee, ": ").concat(processingFee === null || processingFee === void 0 ? void 0 : processingFee.currency, " ").concat(getFormatedProcessingFeeAmount())))), /*#__PURE__*/_react.default.createElement(FieldGroup, {
        flexWrap: isMobile && isPaymentPage
      }, isPaymentPage ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, expiryDateField(props), cvvField(props)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, cardHolderNameField(props), expiryDateField(props), cvvField(props))), isPaymentPage && /*#__PURE__*/_react.default.createElement(FieldGroup, null, cardHolderNameField(props, true)), isPaymentPage && showPaymentCheckbox && disableFields === false && paymentPageCheckbox(), !isPaymentPage && showDefaultCardToggle && /*#__PURE__*/_react.default.createElement(FieldGroup, null, /*#__PURE__*/_react.default.createElement(_GuestPersonalInfo.FieldWrapper, {
        isMobile: isMobile
      }, isToggle ? /*#__PURE__*/_react.default.createElement(StyledSwitchWrapper, null, /*#__PURE__*/_react.default.createElement(_Switch.default, {
        checked: isDefaultCardChecked,
        onChange: defaultCardChangeHandler
      }), renderDefaultCardText()) : /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        accessible: accessible,
        isSelected: isDefaultCardChecked,
        onChange: defaultCardChangeHandler,
        text: renderDefaultCardText(),
        theme: theme,
        disableBottomMargin: true
      }))), showCardAcceptedMessage && /*#__PURE__*/_react.default.createElement(CardAccpetedNoteContainer, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
        color: "primary"
      }, translation.cardAcceptedMessage)), showDefaultCardConfirmationModal && /*#__PURE__*/_react.default.createElement(DefaultCardConfirmationModal, null, /*#__PURE__*/_react.default.createElement(_GenericPopUp.default, {
        accessibility: accessible,
        headingText: language.defaultCardConfirmationModal.headingText,
        mainText: getPreferredPaymentConfirmationText(props),
        handleClick: onConfirmDefaultCard,
        buttonTextOk: language.defaultCardConfirmationModal.primaryButtonText,
        buttonTextLearnMore: language.defaultCardConfirmationModal.secondaryButtonText,
        viewPort: isMobile ? 'mobile' : 'desktop',
        openModal: true,
        showCloseIcon: false,
        primaryButtonProps: _objectSpread({
          buttonType: 'button'
        }, buttonThemeOverrides.primary.true),
        secondaryButtonProps: _objectSpread({
          buttonType: 'button',
          handleClick: onCancelDefaultCard
        }, buttonThemeOverrides.secondary.true)
      })), showDefaultCardInfoModal && /*#__PURE__*/_react.default.createElement(DefaultCardConfirmationModal, null, /*#__PURE__*/_react.default.createElement(_GenericPopUp.default, {
        accessibility: accessible,
        headingText: language.defaultCardInfoModal.headingText,
        mainText: language.defaultCardInfoModal.mainText,
        buttonTextOk: "",
        viewPort: isMobile ? 'mobile' : 'desktop',
        openModal: true,
        showCloseIcon: true,
        handleCloseClick: function handleCloseClick() {
          return setShowDefaultCardInfoModal(false);
        }
      }))))
    );
  }));
};
CreditCardForm.propTypes = _CreditCardForm.default.PropTypes;
CreditCardForm.defaultProps = _CreditCardForm.default.DefaultProps;
var _default = CreditCardForm;
exports.default = _default;